export default "__VITE_ASSET__CnRI$SqY__"